export const ACTIVE_POLICIES = 'ACTIVE_POLICIES';
export const RENEWAL_POLICIES = 'RENEWAL_POLICIES';
export const CANCELLED_POLICIES = 'CANCELLED_POLICIES';
export const COOLING_OFF_POLICIES = 'COOLING_OFF_POLICIES';

export interface IOffPlatformPoliciesStoreRequest {
  product: string;
  insurer: string;
  policy_number: string;
  status: string;
  inception_date: string;
  renewal_date: string;
  payment_type: string;
  premium: number;
  excess: number;
  commission: number;
  datapoints: { name: string; value: string }[];
  client: unknown;
}
